

















import Vue from 'vue'

/* Wrapper class for single selects */
export default Vue.extend({
  name: 'SingleSelect',

  props: {
    value: {
      type: [String, Number, Boolean, Date],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    popperClass: {
      type: String,
      default: '',
    },
  },

  computed: {
    internalValue: {
      get(): any {
        return this.value
      },
      set(value: any): any {
        this.$emit('input', value)
      },
    },
  },
})
